function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7 8C9.1875 8 11 6.21875 11 4C11 1.8125 9.1875 0 7 0C4.78125 0 3 1.8125 3 4C3 6.21875 4.78125 8 7 8ZM7 1.5C8.375 1.5 9.5 2.625 9.5 4C9.5 5.40625 8.375 6.5 7 6.5C5.59375 6.5 4.5 5.40625 4.5 4C4.5 2.625 5.59375 1.5 7 1.5ZM8.5625 9.5H5.40625C2.40625 9.5 0 11.9375 0 14.9375C0 15.5312 0.46875 16 1.0625 16H12.9062C13.5 16 14 15.5312 14 14.9375C14 11.9375 11.5625 9.5 8.5625 9.5ZM1.5 14.5C1.71875 12.5625 3.375 11 5.40625 11H8.5625C10.5938 11 12.2188 12.5625 12.4688 14.5H1.5ZM14.9688 10H12.6562C14.0938 11.1875 15 12.9688 15 14.9375C15 15.3438 14.875 15.6875 14.6875 16H19C19.5312 16 20 15.5625 20 15C20 12.25 17.75 10 14.9688 10ZM13.5 8C15.4062 8 17 6.4375 17 4.5C17 2.59375 15.4062 1 13.5 1C12.6875 1 11.9688 1.28125 11.4062 1.71875C11.75 2.40625 12 3.1875 12 4C12 5.125 11.625 6.15625 11 6.96875C11.625 7.625 12.5 8 13.5 8Z",
  fill: "#767B87"
});

const SvgChangeOwnerAvatar = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgChangeOwnerAvatar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/change_owner_avatar.eeca2c6e.svg";
export { ForwardRef as ReactComponent };